import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { FetchedPartnerAccessInvitation, PartnerAccessInvitationFormData } from '@store';
import { InvitationStatusType } from '../../../projects/client';

export namespace CommercialActions {
  export const fetchPartnerAccessList = createActionGroup({
    source: 'COMMERCIAL fetch invited partner access list',
    events: {
      attempt: emptyProps(),
      success: props<{ invitations: FetchedPartnerAccessInvitation[] }>(),
      error: emptyProps(),
      cancel: emptyProps(),
    },
  });

  export const removePartnerAccessInvitation = createActionGroup({
    source: 'COMMERCIAL remove partner access invitation',
    events: {
      attempt: props<{ token: string; status: InvitationStatusType }>(),
      success: props<{ token: string }>(),
      error: emptyProps(),
    },
  });

  export const updateVisibilityOfPartnerAccessInvitation = createActionGroup({
    source: 'COMMERCIAL update visibility of partner access invitation',
    events: {
      attempt: props<{ token: string; isVisible: boolean }>(),
      success: props<{ token: string }>(),
      error: emptyProps(),
    },
  });

  export const sendPartnerAccessInvitations = createActionGroup({
    source: 'COMMERCIAL send parter access invitations',
    events: {
      'send all': emptyProps(),
      'send one': props<{ index: number }>(), // manual retry
      success: props<{ index: number }>(),
      error: props<{ index: number }>(),
    },
  });

  export const modifyPartnerAccessInvitations = createActionGroup({
    source: 'COMMERCIAL modify parter access invitations',
    events: {
      add: props<{ invitation: PartnerAccessInvitationFormData }>(),
      remove: props<{ index: number }>(),
      clear: emptyProps(),
    },
  });
}
